import * as React from 'react';
import { useParams } from 'react-router-dom';

import { axios } from '../api';
import { InlineSpinner } from '../assets/Spinner';

export const FetchAiUpdates = () => {
  const { agentId } = useParams<{ agentId: string }>();
  const [updates, setUpdates] = React.useState<any[]>([]);
  const [isPolling, setIsPolling] = React.useState(true);
  const intervalRef = React.useRef<number | null>(null);

  React.useEffect(() => {
    setUpdates([]);
    setIsPolling(true);
  }, [agentId]);

  React.useEffect(() => {
    if (!agentId) return;

    const poll = async () => {
      try {
        const res = await axios.get(`/get_agent/${agentId}`);
        setUpdates((prev) => {
          const last = prev[prev.length - 1];
          if (last && JSON.stringify(last) === JSON.stringify(res.data)) return prev;
          return [...prev, res.data];
        });

        // Stop polling if status is 'FINISHED'
        if (res.data.status === 'FINISHED') {
          setIsPolling(false);
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }
      } catch (e) {
        console.error(e);
      }
    };

    poll();

    intervalRef.current = window.setInterval(poll, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [agentId]);

  return (
    <div className="relative h-[calc(100vh-77px)] bg-slate50 p-8">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-xl font-semibold">View Agent Updates</h1>
      </div>
      <div className="mb-3">
        <h2 className="text-sm text-slate-600">
          Agent ID: <span className="font-mono">{agentId}</span>
        </h2>
      </div>

      <div className="bg-white border rounded-lg p-4 shadow-md h-[660px] overflow-y-auto space-y-3">
        {updates.length === 0 ? (
          <div className="text-slate-500 text-sm">Polling... no updates yet</div>
        ) : (
          updates.map((data, i) => (
            <div key={i} className="border rounded p-2 text-sm">
              <div className="flex items-center justify-between">
                {data.status === 'FINISHED' && (
                  <span className="text-green-600 font-semibold">✅ Finished</span>
                )}
                {data.status !== 'FINISHED' && (
                  <span className="flex items-center gap-2 font-medium">
                    {data.status}
                    {isPolling && <InlineSpinner />}
                  </span>
                )}
                <span className="text-xs text-slate-500">#{i + 1}</span>
              </div>
              <b>Task Name</b>: {data.name}
              <br />
              {data.summary && (
                <>
                  <b>Summary</b>: {data.summary} <br />
                </>
              )}
              <b>Agent Link</b>:{' '}
              <a className="cursor-pointer underline text-anchor" href={data.target.url}>
                {data.target.url}
              </a>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
